<template>
	<div>
		<div class="form-group d-flex align-items-center">
			<h1 class="col-xs-11">
				Products
				<router-link :to="{ name: 'create-product' }" tag="button" type="button" class="btn btn-sm btn-primary">
					Create
				</router-link>
			</h1>

			<form class="form-inline d-flex ml-auto col-xs-11">
				<input autofocus class="form-control form-control-sm" type="text" placeholder="Search By Name"
					v-model="name" />
				<button class="btn btn-primary btn-sm ml-1" type="button" @click="Clear()">Clear</button>
			</form>
		</div>
		<div class="alert alert-danger" v-if="error">
			<p class="mb-0">
				{{ error }}
			</p>
		</div>

		<datatable class="mt-4" style="height: 70vh;" :cols="columns" 
			:rows="products.filter(c => c.deleted_at == null).filter(c => name ? c.name.toLowerCase().includes(name.toLowerCase()) : true)" />
	</div>
</template>

<script>
import store from '../../../store';
import { mapState } from 'vuex';
import DataTable from '../../DataTable';
import { createDatatableButtons, getError } from '../../../helpers';

export default {
	components: {
		'datatable': DataTable,
	},

	data() {
		return {
			name: null,
			error: null,

			columns: [
				{ headerName: 'ID', field: 'tag', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 75 },
				{ headerName: 'Name', field: 'name', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 350 },
				{ headerName: 'Category', field: 'category.name', sortable: true, filter: true, resizable: true, minWidth: 150, },
				{ headerName: 'Manufacturer', field: 'manufacturer', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 120 },
				{ headerName: 'Price', field: 'price', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 75 },
				{
					headerName: 'Actions',
					field: 'id',
					minWidth: 90,
					maxWidth: 250,

					cellRenderer: params => {

						const buttons = [
							{
								name: 'Edit',
								type: 'secondary',
								disabled: isDeleted,
								handler: () => {
									this.$router.push({ name: 'edit-product', params: { id: params.value } });
								},
							},
						];
						const isDeleted = !!params.data.deleted_at;

						buttons.push({
							// name: isDeleted ? 'Restore' : 'Delete',
							// type: isDeleted ? 'info' : 'danger',
							name: 'Delete',
							type: 'danger',
							disabled: isDeleted,
							handler: () => {
								if (confirm(`Are you sure you want to delete this product? \nBe careful, all its orders will be canceled !`)) {
									this.error = null;

									this.$store.dispatch(`products/delete`, { productId: params.value })
										.catch(e => {
											this.error = getError(e);
										});
								}
							},
						});

						buttons.push({
							name: params.data.active ? "Out of Stock" : "Available" , 
							type: 'info',
							disabled: isDeleted,
							handler: () => {
								if (confirm(`Are you sure you want to change product status!`)) {
									this.error = null;

									this.$store.dispatch(`products/status`, { productId: params.value, active: !params.data.active })
										.catch(e => {
											this.error = getError(e);
										});
								}
							},
						});

						return createDatatableButtons(buttons);
					}
				}
			],
		};
	},

	computed: {
		...mapState({
			products: state => state.products.products.map(a => ({ ...a })),
		})
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('products/fetchAll');
		next();
	},
	methods: {
		Clear() {
			this.name = null;
		}
	},
	meta: {
		title: 'Products',

		meta: [
			{ property: 'og:title', content: 'Products / Al-Shayah' },
		],
	},
};
</script>

<style scoped>

</style>
